import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";
import { GetAllUsuarios } from "@services/Usuario/Index";

export function useFetchDataAuditores() {
    // Usa o hook genérico para buscar todos os auditores
    const { data, loading, fetchAllData } = useFetchPaginatedData(GetAllUsuarios, 50, { perfil: "AUDITOR"});

    return {
       auditoresOptions: data.map((item) => ({
           value: item.id,
           label: item.nome,
       })).sort((a, b) => a.label.localeCompare(b.label)),
       auditoresLoading: loading,
       fetchAuditores: fetchAllData,
    };
}
